import { ActivityPointSummaryResponseDto } from '@diritto/common/activityPoint/dtos/activity-point-summary.dtos';
import {
  ActivityPointRankExcludedResponseDto,
  ActivityPointRankMyResponseDto,
  ActivityPointRankResponseDto,
  ActivityPointResponseDto,
  ActivityPointSeasonsMyResponseDto,
  ActivityPointSeasonsResponseDto,
} from '@diritto/common/activityPoint/dtos/activity-point.dtos';
import { BasePaginatorDto } from '@diritto/common/base/paginator/paginator.dto';
import { Http } from '@diritto/common/utils/requester/http';
import { generateUrl } from '@diritto/common/utils/urls';
import { AxiosRequestConfig } from 'axios';

export class ActivityPointApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async getSeasons(options?: AxiosRequestConfig) {
    const res = await this.http.get<ActivityPointSeasonsResponseDto>(`${this.url}/activity-points/seasons`, options);
    return res.data;
  }

  async getPoint(options?: AxiosRequestConfig) {
    const res = await this.http.get<ActivityPointResponseDto>(`${this.url}/activity-points`, options);
    return res.data;
  }

  async getExcluded(options?: AxiosRequestConfig) {
    const res = await this.http.get<ActivityPointRankExcludedResponseDto>(
      `${this.url}/activity-points/seasons/current/rank/excluded`,
      options,
    );
    return res.data;
  }

  async getMyRank(options?: AxiosRequestConfig) {
    const res = await this.http.get<ActivityPointRankMyResponseDto>(
      `${this.url}/activity-points/seasons/current/rank/my`,
      options,
    );
    return res.data;
  }

  async getAllRank(options?: AxiosRequestConfig) {
    const res = await this.http.get<ActivityPointRankResponseDto>(
      `${this.url}/activity-points/seasons/current/rank/all`,
      options,
    );
    return res.data;
  }

  async getRankBySeasonId(seasonId: number, options?: AxiosRequestConfig) {
    const res = await this.http.get<ActivityPointRankResponseDto>(
      `${this.url}/activity-points/seasons/${seasonId}/rank/all`,
      options,
    );
    return res.data;
  }

  async getSummary(yearMonthDay: string, options?: AxiosRequestConfig) {
    const res = await this.http.get<ActivityPointSummaryResponseDto>(
      generateUrl(`${this.url}/activity-points/seasons/current/summary`, { yearMonthDay }), // 2022-01-01
      options,
    );
    return res.data;
  }

  async findPastSeasonsRankMy(paginator?: BasePaginatorDto, options?: AxiosRequestConfig) {
    const res = await this.http.get<ActivityPointSeasonsMyResponseDto>(
      generateUrl(`${this.url}/activity-points/seasons/rank/my`, { ...paginator }),
      options,
    );
    return res.data;
  }
}
